import { useMutation } from 'react-query';

import { bulkRollbackInterimStatus as mutationFn } from 'api/endPoints/bulkRollbackInterimStatus';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationBulkRollbackAction = () => {
    return useMutation<string, QueryError, IBulkRollbackActionPayload>((params) => mutationFn(params));
};

interface IBulkRollbackActionPayload {
    filter: {
        filters: IFilter;
    };
    paging: {
        page: number;
        size: number;
    };
    uniqIdNotification: number;
    versionId: number;
}
